import { ActionIcon, useMantineColorScheme } from '@mantine/core';
import { SunIcon, MoonIcon } from '@modulz/radix-icons';

const ThemeSwitch: React.FC = () => {
    const { colorScheme, toggleColorScheme } = useMantineColorScheme();
    const dark = colorScheme === 'dark';
    return (
        <ActionIcon
            variant='outline'
            color={dark ? 'yellow' : 'blue'}
            onClick={() => toggleColorScheme()}
            title='Toggle color scheme'
            ml="xl"
        >
            {dark ? (
                <SunIcon style={{ width: 18, height: 18 }} />
            ) : (
                <MoonIcon style={{ width: 18, height: 18 }} />
            )}
        </ActionIcon>
    );
};

export default ThemeSwitch;